<template>
  <div class="cms-form-group" :class="{ 'cms-form-group-full': fullWidth, 'cms-disabled': disabled }">
    <label v-if="label" :for="selectId">{{ label }}</label>
    <select
      :id="selectId"
      :value="modelValue"
      :disabled="disabled"
      :required="required"
      class="cms-select"
      @change="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
    >
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="(option, key) in options"
        :key="key"
        :value="getOptionValue(option, key)"
      >
        {{ getOptionLabel(option) }}
      </option>
    </select>
    <!-- <span v-if="helpText" class="cms-form-help">{{ helpText }}</span> -->
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
  modelValue: string | number | boolean | null;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  helpText?: string;
  options: Record<string, string> | Array<{ value: string | number | boolean; label: string }>;
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: '',
  disabled: false,
  required: false,
  fullWidth: false
});

defineEmits<{
  (e: 'update:modelValue', value: string | number | boolean | null): void;
}>();

const selectId = computed(() => `cms-select-${Math.random().toString(36).substr(2, 9)}`);

const getOptionValue = (option: any, key: string | number) => {
  if (typeof option === 'object' && 'value' in option) {
    return option.value;
  }
  return key;
};

const getOptionLabel = (option: any) => {
  if (typeof option === 'object' && 'label' in option) {
    return option.label;
  }
  return option;
};
</script>

<!-- 
  Styles: Uses global .cms-form-group and .cms-select classes from cms-styles.scss
  No component-specific styles needed
-->



